export default __webpack_public_path__ + "static/sealmelt-768bf4d72c31601c1a2bd1a5feeb6af1.png";